import {
  AbstractTradingService,
  CreateGenericOfferDto,
  FilterGetTradings,
  ICloseOrderData,
  ICloseOrderResult,
  TradingModel
} from '@aionzdev/modules';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { CatalogosApiService } from './api/catalogos-api.service';

const NOT_SUPPORTED = 'Ação não suportada no contexto de Catálogos';

/**
 * `FilterGetTradings` da lib só tem `idEmpresa`, mas canais sem empresa
 * vinculada filtram pelo dono via `idUsuario` (ver CanalService.getOffersChannel
 * no ebarn-app) — estende o filtro público com o campo que falta nele.
 */
export interface CatalogosFilterGetTradings extends FilterGetTradings {
  idUsuario?: string | number;
}

@Injectable({ providedIn: 'root' })
export class TradingService extends AbstractTradingService {
  private readonly _api = inject(CatalogosApiService);

  override getOne(tradingId: string): Observable<TradingModel> {
    return this._api.findOfertaById(tradingId);
  }

  override getAllView(filter?: CatalogosFilterGetTradings): Observable<TradingModel[]> {
    return this._api.findAllOfertas({
      status: (filter?.status as string[]) ?? ['PUBLICADA', 'EM_NEGOCIACAO'],
      order: filter?.order ?? 'padrao',
      page: filter?.page ?? 1,
      pageSize: filter?.pageSize ?? 10,
      idUsuario: filter?.idUsuario,
      idEmpresa: filter?.idEmpresa
    });
  }

  override increaseView(interactionId: number): Observable<void> {
    return this._api.registerView(interactionId);
  }

  override addClick(interactionId: number): Observable<void> {
    return this._api.registerClick(interactionId);
  }

  override createGeneric(_data: CreateGenericOfferDto): Observable<TradingModel> {
    return throwError(() => new Error(NOT_SUPPORTED));
  }

  override markTradeAsSaved(_interactionId: number): Observable<void> {
    return throwError(() => new Error(NOT_SUPPORTED));
  }

  override sendMessage(_trading: TradingModel): void {
    throw new Error(NOT_SUPPORTED);
  }

  override consultancyRequest(_trading: TradingModel): void {
    throw new Error(NOT_SUPPORTED);
  }

  override closeOrder(_data: ICloseOrderData): Observable<ICloseOrderResult> {
    return throwError(() => new Error(NOT_SUPPORTED));
  }

  override impulseOffer(_tradingId: string | number, _option: number): void {
    throw new Error(NOT_SUPPORTED);
  }

  override recomendar(_data: { id: string }): Observable<TradingModel> {
    return throwError(() => new Error(NOT_SUPPORTED));
  }

  override adicionarCashback(_data: { id: string; cashback: number }): Observable<TradingModel> {
    return throwError(() => new Error(NOT_SUPPORTED));
  }

  override delete(_tradingId: string | number, _motivo: string): Observable<void> {
    return throwError(() => new Error(NOT_SUPPORTED));
  }
}
